<template>
  <div class="d-flex align-center" style="width: 100%">
    <v-btn text color="primary" large variant="outlined" style="border-color: white !important;">
      <div class="d-flex align-center">
        <v-icon left color="primary" class="big-calendar-icon">mdi-calendar</v-icon>
        <div class="pl-2 date-button">{{ formattedDate }}</div>
      </div>
    </v-btn>

    <div>
      <v-btn @click="subtract" text color="primary" variant="outlined" style="border-color: white !important;">
        <v-icon left>mdi-chevron-left</v-icon>
        前の月
      </v-btn>
    </div>
    <div>
      <v-btn @click="add" text color="primary" variant="outlined" style="border-color: white !important;">
        次の月
        <v-icon right>mdi-chevron-right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dayjs from "dayjs";
import "dayjs/locale/ja";

export default defineComponent({
  name: "DatePager",
  props: {
    // Vue3のv-modelはデフォルトでmodelValueを受け取ります
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"], // Vue3ではemitsを宣言するのが推奨されます
  setup(props, { emit }) {
    dayjs.locale("ja");

    const formatString = "YYYY年MM月";

    return {
      formatString,
    };
  },
  computed: {
    formattedDate(): string {
      return dayjs(this.modelValue).format(this.formatString);
    },
  },
  methods: {
    add() {
      const newValue = dayjs(this.modelValue).add(1, "month").format("YYYY-MM");
      this.$emit("update:modelValue", newValue);
    },
    subtract() {
      const newValue = dayjs(this.modelValue).subtract(1, "month").format("YYYY-MM");
      this.$emit("update:modelValue", newValue);
    },
  },
});
</script>

<style scoped>
.date-button {
  font-size: 1.4rem;
}
.big-calendar-icon {
  font-size: 2.3rem !important;
  width: auto;
  height: auto;
}
</style>
